var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _ from 'lodash';
function findProperty(obj, targetProperty) {
    var _a;
    // Special case for PrimaryBusiness remains unchanged
    if (targetProperty === 'PrimaryBusiness') {
        var findBrizaKey_1 = function (currentObj) {
            for (var _i = 0, _a = Object.entries(currentObj); _i < _a.length; _i++) {
                var _b = _a[_i], k = _b[0], v = _b[1];
                if (k.startsWith('Briza_PrimaryBusiness_'))
                    return v;
                if (v && typeof v === 'object') {
                    var nestedResult = findBrizaKey_1(v);
                    if (nestedResult !== undefined)
                        return nestedResult;
                }
            }
            return undefined;
        };
        return findBrizaKey_1(obj);
    }
    // If targetProperty contains dot notation, use nested object traversal
    if (targetProperty.includes('.')) {
        var parts = targetProperty.split('.');
        var current = obj;
        for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
            var part = parts_1[_i];
            if (!current || typeof current !== 'object') {
                return null;
            }
            current = current[part];
        }
        return current !== null && current !== void 0 ? current : null;
    }
    // If no dot notation, flatten the object and search
    var flattenObject = function (obj, prefix) {
        if (prefix === void 0) { prefix = ''; }
        return Object.keys(obj).reduce(function (acc, key) {
            var value = obj[key];
            var newKey = prefix ? "".concat(prefix, ".").concat(key) : key;
            if (value && typeof value === 'object' && !Array.isArray(value)) {
                Object.assign(acc, flattenObject(value, newKey));
                acc[key] = value; // Also keep the original key
            }
            else {
                acc[key] = value;
            }
            return acc;
        }, {});
    };
    var flattenedObj = flattenObject(obj);
    return (_a = flattenedObj[targetProperty]) !== null && _a !== void 0 ? _a : null;
}
var getQuestionKeysFromOperands = function (operands, tempAnswers, allAnswers) {
    // Helper to extract $ keys from one operand
    var extractDollarKeys = function (operand) {
        var keys = Array.isArray(operand) ? operand : [operand];
        if (keys.every(function (k) { return typeof k === 'string' && k.startsWith('$'); })) {
            return keys.map(function (k) { return k.substring(1); });
        }
        return [];
    };
    // 3️⃣ Fallback: check which keys exist in answers
    var extractKeysFromAnswers = function (operand) {
        var keys = Array.isArray(operand) ? operand : [operand];
        if (keys.some(function (k) { return typeof k !== 'string'; }))
            return [];
        return keys.filter(function (key) {
            var _a;
            var answerValue = (_a = findProperty(tempAnswers, key)) !== null && _a !== void 0 ? _a : findProperty(allAnswers, key);
            return answerValue !== undefined && answerValue !== null;
        });
    };
    var keysFromFirst = extractDollarKeys(operands[0]);
    var keysFromSecond = extractDollarKeys(operands[1]);
    var keysFromFirstAnswerCheck = extractKeysFromAnswers(keysFromFirst.length ? keysFromFirst : operands[0]);
    var keysFromSecondAnswerCheck = extractKeysFromAnswers(keysFromSecond.length ? keysFromSecond : operands[1]);
    if (keysFromFirstAnswerCheck.length && keysFromSecondAnswerCheck.length) {
        return {
            questionKeys: __spreadArray(__spreadArray([], keysFromFirstAnswerCheck, true), keysFromSecondAnswerCheck, true),
            ansIndex: -1
        };
    }
    if (keysFromFirst.length && keysFromSecond.length) {
        return {
            questionKeys: __spreadArray(__spreadArray([], keysFromFirst, true), keysFromSecond, true),
            ansIndex: -1
        };
    }
    if (keysFromFirst.length)
        return { questionKeys: keysFromFirst, ansIndex: 1 };
    if (keysFromSecond.length)
        return { questionKeys: keysFromSecond, ansIndex: 0 };
    if (keysFromFirstAnswerCheck.length)
        return { questionKeys: keysFromFirstAnswerCheck, ansIndex: 1 };
    if (keysFromSecondAnswerCheck.length)
        return { questionKeys: keysFromSecondAnswerCheck, ansIndex: 0 };
    return null;
};
var handleSimpleConditions = function (conditions, tempAnswers, allAnswers) {
    var _a;
    var targetValue = (_a = findProperty(tempAnswers, conditions.targetKey)) !== null && _a !== void 0 ? _a : findProperty(allAnswers, conditions.targetKey);
    if (conditions.requiresIncl) {
        if (targetValue &&
            typeof targetValue === 'string' &&
            targetValue
                .toLowerCase()
                .includes("".concat(conditions.requiresIncl).toLowerCase())) {
            return true;
        }
    }
    if (conditions.requiresExact && targetValue) {
        var requiresExact = conditions.requiresExact;
        var isConditionArray = Array.isArray(requiresExact);
        var isValueArray = Array.isArray(targetValue);
        if (isConditionArray && isValueArray) {
            return requiresExact.some(function (reqVal) { return targetValue.includes(reqVal); });
        }
        else if (isConditionArray) {
            return requiresExact.includes(targetValue);
        }
        else if (isValueArray) {
            return targetValue.includes(conditions.requiresExact);
        }
        else {
            return (targetValue.toString().toLowerCase() ===
                requiresExact.toString().toLowerCase());
        }
    }
    if (conditions.setsMin || conditions.setsMax) {
        return true; // Implementation depends on your specific needs
    }
    if (conditions.repeatsByValue) {
        return targetValue === conditions.repeatsByValue;
    }
    if (conditions.hidesIfTargetVal && targetValue) {
        var isValueArray = Array.isArray(targetValue);
        if (isValueArray) {
            return targetValue.every(function (v) { return v !== conditions.hidesIfTargetVal; });
        }
        else {
            return (targetValue.toString().toLowerCase() ===
                conditions.hidesIfTargetVal.toString().toLowerCase());
        }
    }
    return false;
};
var handleConditions = function (conditions, tempAnswers, allAnswers) {
    if (tempAnswers === void 0) { tempAnswers = {}; }
    if (allAnswers === void 0) { allAnswers = {}; }
    // If no conditions, show by default
    if (!conditions)
        return true;
    // Check for simple conditions first (backwards compatibility)
    if (('requiresIncl' in conditions ||
        'requiresExact' in conditions ||
        'setsMin' in conditions ||
        'setsMax' in conditions ||
        'repeatsByValue' in conditions ||
        'hidesIfTargetVal' in conditions) &&
        (conditions.requiresIncl ||
            conditions.requiresExact ||
            conditions.setsMin ||
            conditions.setsMax ||
            conditions.repeatsByValue ||
            conditions.hidesIfTargetVal)) {
        return handleSimpleConditions(conditions, tempAnswers, allAnswers);
    }
    if ('complexCondition' in conditions && conditions.complexCondition) {
        return !!evaluateComplexCondition(conditions.complexCondition, tempAnswers, allAnswers);
    }
    if ('x-condition' in conditions && conditions['x-condition']) {
        return !!evaluateComplexCondition(conditions['x-condition'], tempAnswers, allAnswers);
    }
    // Handle Multi Conditional Statements Array Based
    if (Array.isArray(conditions) && conditions.length > 0) {
        return conditions.every(function (condition) {
            return handleConditions(condition, tempAnswers, allAnswers);
        });
    }
    // Default to false if no recognized conditions
    return false;
};
var resolveOperandValue = function (operand, tempAnswers, allAnswers) {
    var _a;
    if (Array.isArray(operand)) {
        return evaluateComplexCondition(operand, tempAnswers, allAnswers);
    }
    if (typeof operand === 'string' && operand.startsWith('$')) {
        var key = operand.substring(1);
        return (_a = findProperty(tempAnswers, key)) !== null && _a !== void 0 ? _a : findProperty(allAnswers, key);
    }
    return operand;
};
var evaluateAddition = function (operands, tempAnswers, allAnswers) {
    return operands.reduce(function (acc, op) {
        return acc + (Number(resolveOperandValue(op, tempAnswers, allAnswers)) || 0);
    }, 0);
};
var evaluateSubtraction = function (operands, tempAnswers, allAnswers) {
    return operands.reduce(function (acc, op, idx) {
        var val = Number(resolveOperandValue(op, tempAnswers, allAnswers)) || 0;
        return idx === 0 ? val : acc - val;
    }, 0);
};
var evaluateMultiplication = function (operands, tempAnswers, allAnswers) {
    return operands.reduce(function (acc, op) {
        return acc * (Number(resolveOperandValue(op, tempAnswers, allAnswers)) || 0);
    }, 1);
};
export var evaluateComplexCondition = function (condition, tempAnswers, allAnswers) {
    if (!Array.isArray(condition))
        return false;
    var operator = String(condition[0]).toUpperCase();
    var operands = condition.slice(1);
    switch (operator) {
        case 'AND':
            return operands.every(function (cond) {
                return evaluateComplexCondition(cond, tempAnswers, allAnswers);
            });
        case 'OR':
            return operands.some(function (cond) {
                return evaluateComplexCondition(cond, tempAnswers, allAnswers);
            });
        case 'NOT':
            if (Array.isArray(operands[0]) && operands[0][0] === 'IN') {
                return !evaluateInCondition(operands[0].slice(1), tempAnswers, allAnswers);
            }
            return !evaluateComplexCondition(operands[0], tempAnswers, allAnswers);
        case 'IN':
            return evaluateInCondition(operands, tempAnswers, allAnswers);
        case 'NOT IN':
            return !evaluateInCondition(operands, tempAnswers, allAnswers);
        case 'OVERLAP':
            return evaluateOverlapCondition(operands, tempAnswers, allAnswers);
        case '==':
            return evaluateEqualityCondition(operands, tempAnswers, allAnswers, false);
        case '!=':
            return evaluateEqualityCondition(operands, tempAnswers, allAnswers, true);
        case 'PRESENT':
            return evaluatePresentCondition(operands, tempAnswers, allAnswers);
        case '>':
        case '<':
        case '>=':
        case '<=':
            return evaluateComparisonCondition(operator, operands, tempAnswers, allAnswers);
        case '+':
            return evaluateAddition(operands, tempAnswers, allAnswers);
        case '-':
            return evaluateSubtraction(operands, tempAnswers, allAnswers);
        case '*':
            return evaluateMultiplication(operands, tempAnswers, allAnswers);
        default:
            console.error("Unknown operator: ".concat(operator));
            return false;
    }
};
var evaluateEqualityCondition = function (operands, tempAnswers, allAnswers, negate) {
    var _a, _b;
    if (negate === void 0) { negate = false; }
    if (!Array.isArray(operands) || operands.length !== 2) {
        console.error('Invalid equality condition structure. Expected [questionKey, value]', operands);
        return false;
    }
    // Handle cases where operands might be nested arrays (math/logic)
    if (Array.isArray(operands[0]) || Array.isArray(operands[1])) {
        var val1 = resolveOperandValue(operands[0], tempAnswers, allAnswers);
        var val2 = resolveOperandValue(operands[1], tempAnswers, allAnswers);
        var isEqual_1 = looseEquals(val1, val2);
        return negate ? !isEqual_1 : isEqual_1;
    }
    var keyInfo = getQuestionKeysFromOperands(operands, tempAnswers, allAnswers);
    if (!keyInfo)
        return false;
    var questionKeys = keyInfo.questionKeys, ansIndex = keyInfo.ansIndex;
    var isEqual;
    if (ansIndex < 0 && questionKeys.length === 2) {
        var value1 = (_a = findProperty(tempAnswers, questionKeys[0])) !== null && _a !== void 0 ? _a : findProperty(allAnswers, questionKeys[0]);
        var value2 = (_b = findProperty(tempAnswers, questionKeys[1])) !== null && _b !== void 0 ? _b : findProperty(allAnswers, questionKeys[1]);
        isEqual = value1 !== null && value2 !== null && looseEquals(value1, value2);
    }
    else {
        var expectedValue_1 = operands[ansIndex];
        isEqual = questionKeys.some(function (key) {
            var _a;
            var actualValue = (_a = findProperty(tempAnswers, key)) !== null && _a !== void 0 ? _a : findProperty(allAnswers, key);
            return actualValue !== null && looseEquals(actualValue, expectedValue_1);
        });
    }
    // If the operator is '!=', negate the result of the base check.
    return negate ? !isEqual : isEqual;
};
var looseEquals = function (a, b) {
    // Handle undefined/null cases
    if (a == null || b == null)
        return a === b;
    // Special case for booleans
    if (typeof a === 'boolean' || typeof b === 'boolean') {
        var aVal = a;
        var bVal = b;
        if (typeof aVal !== 'boolean') {
            aVal = aVal === 'true' ? true : false;
        }
        if (typeof bVal !== 'boolean') {
            bVal = bVal === 'true' ? true : false;
        }
        return Boolean(aVal) === Boolean(bVal);
    }
    // Compare numbers numerically even if one is string
    if (!isNaN(Number(a)) && !isNaN(Number(b))) {
        return Number(a) === Number(b);
    }
    // String comparison (case insensitive for strings)
    if (typeof a === 'string' && typeof b === 'string') {
        return a.trim().toLowerCase() === b.trim().toLowerCase();
    }
    // Default to JavaScript's == behavior
    return a == b;
};
var evaluateComparisonCondition = function (operator, operands, tempAnswers, allAnswers) {
    var _a, _b;
    if (!Array.isArray(operands) || operands.length !== 2)
        return false;
    var validate = function (value1, value2) {
        switch (operator) {
            case '>':
                return value1 > value2;
            case '<':
                return value1 < value2;
            case '>=':
                return value1 >= value2;
            case '<=':
                return value1 <= value2;
            default:
                return false;
        }
    };
    // If either operand is a nested logic/math array, resolve it first
    if (Array.isArray(operands[0]) || Array.isArray(operands[1])) {
        var val1 = Number(resolveOperandValue(operands[0], tempAnswers, allAnswers));
        var val2 = Number(resolveOperandValue(operands[1], tempAnswers, allAnswers));
        if (isNaN(val1) || isNaN(val2))
            return false;
        return validate(val1, val2);
    }
    var keyInfo = getQuestionKeysFromOperands(operands, tempAnswers, allAnswers);
    if (!keyInfo)
        return false;
    var questionKeys = keyInfo.questionKeys, ansIndex = keyInfo.ansIndex;
    if (ansIndex < 0 && questionKeys.length === 2) {
        var value1 = (_a = findProperty(tempAnswers, questionKeys[0])) !== null && _a !== void 0 ? _a : findProperty(allAnswers, questionKeys[0]);
        var value2 = (_b = findProperty(tempAnswers, questionKeys[1])) !== null && _b !== void 0 ? _b : findProperty(allAnswers, questionKeys[1]);
        var numberVal1 = Number("".concat(value1).replace(/[^-\d.]+/g, ''));
        var numberVal2 = Number("".concat(value2).replace(/[^-\d.]+/g, ''));
        return (!(value1 === null ||
            value2 === null ||
            isNaN(numberVal1) ||
            isNaN(numberVal2)) && validate(numberVal1, numberVal2));
    }
    else {
        var comparisonValue = operands[ansIndex];
        var numberVal2_1 = Number("".concat(comparisonValue).replace(/[^-\d.]+/g, ''));
        if (isNaN(numberVal2_1))
            return false;
        // The condition is true if ANY of the question values passes the comparison
        return questionKeys.some(function (key) {
            var _a;
            var targetValue = (_a = findProperty(tempAnswers, key)) !== null && _a !== void 0 ? _a : findProperty(allAnswers, key);
            var numberVal1 = Number("".concat(targetValue).replace(/[^-\d.]+/g, ''));
            if (numberVal1 === null || isNaN(numberVal1))
                return false;
            return validate(numberVal1, numberVal2_1);
        });
    }
};
var evaluateInCondition = function (operands, tempAnswers, allAnswers) {
    if (!Array.isArray(operands) || operands.length < 2)
        return false;
    var keyInfo = getQuestionKeysFromOperands(operands, tempAnswers, allAnswers);
    if (!keyInfo)
        return false;
    var questionKeys = keyInfo.questionKeys, ansIndex = keyInfo.ansIndex;
    if (ansIndex === -1)
        return false;
    var answer = operands[ansIndex];
    var expectedValues = Array.isArray(answer) ? answer : [answer];
    return questionKeys.some(function (questionKey) {
        var _a;
        var answerValue = (_a = findProperty(tempAnswers, questionKey)) !== null && _a !== void 0 ? _a : findProperty(allAnswers, questionKey);
        if (answerValue === undefined || answerValue === null)
            return false;
        // Handle both array and single value answers
        var answerValues = Array.isArray(answerValue)
            ? answerValue
            : [answerValue];
        return answerValues.some(function (val) {
            return expectedValues.some(function (target) { return String(val).trim() === String(target).trim(); });
        });
    });
};
var evaluateOverlapCondition = function (operands, tempAnswers, allAnswers) {
    if (!Array.isArray(operands) || operands.length < 2)
        return false;
    var keyInfo = getQuestionKeysFromOperands(operands, tempAnswers, allAnswers);
    if (!keyInfo)
        return false;
    var questionKeys = keyInfo.questionKeys, ansIndex = keyInfo.ansIndex;
    var answer = operands[ansIndex];
    var expectedValues = Array.isArray(answer) ? answer : [answer];
    // The condition is true if ANY of the questions has an overlapping value
    return questionKeys.some(function (key) {
        var _a;
        var answerValue = (_a = findProperty(tempAnswers, key)) !== null && _a !== void 0 ? _a : findProperty(allAnswers, key);
        if (answerValue === undefined || answerValue === null)
            return false;
        var answerArray = Array.isArray(answerValue)
            ? answerValue
            : [answerValue];
        return answerArray.some(function (item) {
            return expectedValues.some(function (target) { return String(item).trim() === String(target).trim(); });
        });
    });
};
var evaluatePresentCondition = function (operands, tempAnswers, allAnswers) {
    if (!Array.isArray(operands) || operands.length < 1)
        return false;
    var rawKeys = operands[0];
    var questionKeys = (Array.isArray(rawKeys) ? rawKeys : [rawKeys]).map(function (k) { return (k.startsWith('$') ? k.substring(1) : k); });
    // The condition is true only if ALL of the questions are present
    return questionKeys.every(function (key) {
        var _a;
        var answerValue = (_a = findProperty(tempAnswers, key)) !== null && _a !== void 0 ? _a : findProperty(allAnswers, key);
        return (answerValue !== undefined &&
            answerValue !== null &&
            (typeof answerValue !== 'string' || answerValue.trim() !== ''));
    });
};
// export const findQuestionsWithConditions = (
//   questions: Question[],
//   tempAnswers: any,
//   answers: any,
// ) => {
//   let removedQuestionsLocal: string[] = [];
//   for (const q of questions) {
//     if (q.conditions && !handleConditions(q.conditions, tempAnswers, answers)) {
//       removedQuestionsLocal.push(q.questionKey as string);
//     }
//     if (q.inputType === 'group') {
//       const groupRemovedQuestions = findQuestionsWithConditions(
//         q.questions!,
//         tempAnswers,
//         answers,
//       );
//       if (groupRemovedQuestions && groupRemovedQuestions.length > 0) {
//         groupRemovedQuestions.forEach((item) => {
//           removedQuestionsLocal.push(`${q.questionKey}.${item}`);
//         });
//       }
//     }
//   }
//   return removedQuestionsLocal;
// };
export var findQuestionsWithConditions = function (questions, tempAnswers, answers, parentKey) {
    var removedQuestionsLocal = [];
    var allAnswers = __assign(__assign({}, answers), tempAnswers);
    var _loop_1 = function (q) {
        var currentQuestionKey = parentKey
            ? "".concat(parentKey, ".").concat(q.questionKey)
            : q.questionKey;
        var conditions = q.conditions;
        if (conditions) {
            var isQuestionAdded = handleConditions(conditions, tempAnswers, answers);
            if (!isQuestionAdded) {
                removedQuestionsLocal.push(currentQuestionKey);
            }
            else {
                if (('repeatGroupKey' in conditions || 'requiresExact' in conditions) &&
                    conditions.repeatGroupKey &&
                    conditions.requiresExact &&
                    parentKey) {
                    var isConditionArray = Array.isArray(conditions.requiresExact);
                    var lastitem = parentKey.split('_').pop();
                    if (lastitem) {
                        var matches = false;
                        if (isConditionArray) {
                            matches = conditions.requiresExact.includes(lastitem);
                        }
                        else {
                            matches =
                                lastitem.toString().toLowerCase() ===
                                    conditions.requiresExact.toString().toLowerCase();
                        }
                        if (!matches) {
                            removedQuestionsLocal.push(currentQuestionKey);
                        }
                    }
                }
            }
        }
        if (q.inputType === 'group' && q.questions) {
            if (q.repeatBy) {
                var repeatKeys = [];
                var targetValue = findProperty(allAnswers, q.repeatBy.targetKey);
                var targetQuestion = questions.find(function (sectionQuestion) { var _a; return sectionQuestion.questionKey === ((_a = q.repeatBy) === null || _a === void 0 ? void 0 : _a.targetKey); });
                if ((targetQuestion === null || targetQuestion === void 0 ? void 0 : targetQuestion.inputType) === 'number' &&
                    typeof targetValue === 'number' &&
                    targetValue > -1) {
                    repeatKeys = Array.from({ length: targetValue }, function (_, i) {
                        return (i + 1).toString();
                    });
                }
                else if ((targetQuestion === null || targetQuestion === void 0 ? void 0 : targetQuestion.inputType) === 'multiselect' &&
                    Array.isArray(targetValue)) {
                    repeatKeys = targetValue;
                }
                if (repeatKeys.length > 0) {
                    repeatKeys.forEach(function (repeatKey) {
                        var groupInstanceKey = "".concat(q.questionKey, "_").concat(repeatKey);
                        var instanceAnswers = findProperty(allAnswers, groupInstanceKey) || {};
                        var groupRemovedQuestions = findQuestionsWithConditions(q.questions, instanceAnswers, allAnswers, groupInstanceKey);
                        removedQuestionsLocal.push.apply(removedQuestionsLocal, groupRemovedQuestions);
                    });
                }
            }
            else {
                var groupInstanceKey = q.questionKey;
                var instanceAnswers = findProperty(allAnswers, groupInstanceKey) || {};
                var groupRemovedQuestions = findQuestionsWithConditions(q.questions, instanceAnswers, allAnswers, groupInstanceKey);
                removedQuestionsLocal.push.apply(removedQuestionsLocal, groupRemovedQuestions);
            }
        }
    };
    for (var _i = 0, questions_1 = questions; _i < questions_1.length; _i++) {
        var q = questions_1[_i];
        _loop_1(q);
    }
    return removedQuestionsLocal;
};
export var pruneStaleValues = function (sectionAnswers, allAnswers, allQuestions, sectionKey) {
    var _a;
    var removedQuestions = findQuestionsWithConditions(allQuestions, (_a = {}, _a[sectionKey] = sectionAnswers, _a), allAnswers);
    var filteredQuestions = allQuestions.filter(function (q) { return !removedQuestions.includes(q.questionKey); });
    var formValues = JSON.parse(JSON.stringify(sectionAnswers || {}));
    for (var _i = 0, removedQuestions_1 = removedQuestions; _i < removedQuestions_1.length; _i++) {
        var key = removedQuestions_1[_i];
        _.unset(formValues, key);
    }
    var _loop_2 = function (i) {
        var ques = filteredQuestions[i];
        if (ques.inputType === 'group' && ques.repeatBy) {
            var repeatKeys = [''];
            var value = formValues[ques.repeatBy.targetKey];
            var config = allQuestions.find(function (q) { var _a; return q.questionKey === ((_a = ques.repeatBy) === null || _a === void 0 ? void 0 : _a.targetKey); });
            if ((config === null || config === void 0 ? void 0 : config.inputType) === 'number') {
                if (typeof value === 'number' && value > -1) {
                    repeatKeys = Array.from({ length: value }).map(function (_, i) {
                        return (i + 1).toString();
                    });
                }
                else {
                    repeatKeys = [];
                }
            }
            else if ((config === null || config === void 0 ? void 0 : config.inputType) === 'multiselect') {
                if (Array.isArray(value)) {
                    repeatKeys = value;
                }
                else {
                    repeatKeys = [];
                }
            }
            var validKeys = new Set(repeatKeys
                .filter(Boolean)
                .map(function (repeatKey) { return "".concat(ques.questionKey, "_").concat(repeatKey); }));
            for (var _b = 0, _c = Object.keys(formValues); _b < _c.length; _b++) {
                var key = _c[_b];
                if (key.startsWith("".concat(ques.questionKey, "_")) && !validKeys.has(key)) {
                    _.unset(formValues, key);
                }
            }
        }
    };
    for (var i = 0; i < filteredQuestions.length; i++) {
        _loop_2(i);
    }
    return formValues;
};
